<template>
  <div>
    <b-badge :style="params.colDef.field === 'inspectionStatus' ? 'width: 65%' : ''" :class="params.colDef.field === 'inspectionStatus' ? ['ADMIN'].includes(userType) ? 'w-50' : 'w-70' : 'w-100'" :variant="color(params)">
      <fa-icon :icon="icon(params)" />
      <span style="    font-size: 9px;" v-if="params.colDef.field === 'inspectionStatus'">
      {{ params.data.recording_date }}
    </span>
      <span v-if="params.colDef.field === 'inspectionStatus' && params.data.inspectionStatusCurrentYear" style="margin-left: 4px;">| ≤ {{ params.data.inspectionStatusCurrentYear - 1 }}</span>
    </b-badge>
    <b-badge :style="['ADMIN'].includes(userType) ? 'width: 25%' : 'width: 35%'" class="ml-1 w-30" :variant="colorCurrent(params)" v-if="params.colDef.field === 'inspectionStatus' && params.data.inspectionStatusCurrentYear ">
      {{ params.data.inspectionStatusCurrentYear }}
      <span style="    font-size: 9px;" v-if="['ADMIN', 'VIEWER'].includes(userType) && params.colDef.field === 'inspectionStatus'">
      ({{ params.data.taxDebt }})
    </span>
    </b-badge>
    <b-badge :variant="colorCO(params)" style="width: 22%" class="ml-1" v-if="['ADMIN'].includes(userType) && params.colDef.field === 'inspectionStatus'">
      <fa-icon icon="leaf" />
      <span v-i style="margin-left: 10px;">{{ params.data.coPayment ? params.data.coPayment : '-' }}</span>
    </b-badge>
  </div>
</template>

<script>

import { BBadge } from 'bootstrap-vue'
import VueCountdown from '@chenfengyuan/vue-countdown';
import store from '@/store'
import techServiceModule from '@/store/tech-service/techServiceModule'

export default {
  name: 'cell-renderer-can-edit',
  components: {
    BBadge,
    VueCountdown
  },
  data() {
    return {
      TECH_SERVICE_STORE_MODULE_NAME: 'techServiceModule',
    }
  },
  computed: {

    userType () {
      return atob(this.$store.state.user_type)
    },

    color () {
      return (item) => {
        if(item.value === false) {
          return 'danger'
        } else if (item.value === true) {
          return 'success'
        } else {
          return 'warning'
        }
      }
    },
    colorCurrent () {
      return (item) => {
        if(item.data.inspectionStatusCurrent === false) {
          return 'danger'
        } else if (item.data.inspectionStatusCurrent === true) {
          return 'success'
        } else {
          return 'warning'
        }
      }
    },
    colorCO () {
      return (item) => {
        if (item.data.coPayment) {
          if (item.data.coPayment === item.data.EkoSum) {
            return 'success'
          } else {
            return 'danger'
          }
        }
        return 'warning';
      }
    },
    icon() {
      return (item) => {
        if(item.value === false) {
          return 'times-circle'
        } else if (item.value === true) {
          return 'check-circle'
        } else {
          return 'info-circle'
        }
      }
    }

  }
}
</script>
